var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"mainPage"},[_c('section',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.work.imageUrl,"alt":_vm.work.title}})]),_c('footer',{staticClass:"workInfo"},[_c('h1',[_vm._v(_vm._s(_vm.work.title))]),(
        !_vm.$store.state.visitWorks
          .map((work) => work.harvardId)
          .includes(_vm.work.harvardId)
      )?_c('button',{on:{"click":() => _vm.addWork(_vm.work.harvardId)}},[_vm._v(" Collect Work ")]):_c('button',{attrs:{"disabled":""}},[_vm._v("Work is Already Collected")]),_c('button',{staticClass:"cancel",on:{"click":function($event){return _vm.$router.push({ name: 'Current Visit' })}}},[_vm._v(" Cancel ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }